export const NOTIFICATION_ERROR_TYPE = "NOTIFICATION_ERROR_TYPE"

export const buildNotificationError = (message: string) => (error: any) => {
  return Promise.reject({
    message,
    error,
    type: NOTIFICATION_ERROR_TYPE,
  })
}
